import React from 'react';
import PropTypes from 'prop-types';

import { withCommon } from '../../components';
import { resolveLocalizedValue } from '../../common/utils';
import config from '../../static/themes/config';

/**
 * @file Represents About Us page
 *
 * @param {string} language - active site language
 * @param {string} siteName - site name
 *
 * @author A. Green
 */

const AboutUsPage = withCommon({
    store: ({ store }) => ({
        language: store.user.language,
    }),
    propTypes: {
        language: PropTypes.string.isRequired,
    },
    isTrans: true,
})(({ trans, language }) => {
    const paragraphs = resolveLocalizedValue(config.aboutUs, language);

    return (
        <div className="ll-page about-us">
            <div className="about-us__header">{trans('About Us')}</div>
            <div className="about-us__content">
                {Array.isArray(paragraphs)
                    ? paragraphs.map((paragraph, i) => (
                        <p style={{paddingBottom: 10}} key={i} dangerouslySetInnerHTML={{ __html: paragraph }} />
                      ))
                    : null}
            </div>
        </div>
    );
});

export default AboutUsPage;
